import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { CustomMarkdown } from "../components/CustomMarkdown";
import { fetchMarkdown, type MarkdownPost } from "../utils/data";
import Breadcrumb from "../components/Breadcrumb";
import ControlActions from "../components/ControlActions";
import { Smartphone, Layout, PenTool, Box, Grid, Globe, Cpu, Code, Layers, Share2, Bookmark } from 'lucide-react';

const iconMap: Record<string, any> = {
    Smartphone, Layout, PenTool, Box, Grid, Globe, Cpu, Code, Layers
};

export default function ProjectDetail({ slug }: { slug: string }) {
    const [post, setPost] = useState<MarkdownPost | null>(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        fetchMarkdown(`/data/projects/${slug}.md`, slug)
            .then(setPost)
            .catch(() => setError(true));
    }, [slug]);

    if (error) return <div className="text-white text-center py-20">Proje bulunamadı.</div>;
    if (!post) return <div className="text-white text-center py-20">Yükleniyor...</div>;

    const { frontmatter, content } = post;
    const IconComponent = frontmatter.icon && iconMap[frontmatter.icon] ? iconMap[frontmatter.icon] : Layers;

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25, ease: "circOut" }}
            style={{ willChange: "transform, opacity" }}
            className="min-h-screen py-20 px-4 md:py-10 pb-32"
        >
            <div className="max-w-5xl mx-auto">
                {/* Header Removed as per request */}


                {/* Control Row */}
                <div className="flex items-center gap-4 mb-8">
                    {/* Breadcrumb Box */}
                    <div className="flex-grow bg-[#0F0F0F] rounded-[20px] border-2 border-[#2A2A2A] px-8 flex items-center h-[54px] shadow-sm">
                        <Breadcrumb
                            items={[
                                { label: "Projects", href: "/projects" },
                                { label: frontmatter.title }
                            ]}
                        />
                    </div>

                    {/* Actions */}
                    <ControlActions title={frontmatter.title} hideSaveOnMobile={true} />
                </div>

                {/* Content */}
                {/* Content Card */}
                {/* Content Card */}
                <div className="bg-[var(--card-bg)] rounded-[20px] border-2 border-[#2A2A2A] p-8 md:p-12 relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-[var(--accent)]/5 to-transparent pointer-events-none" />
                    <CustomMarkdown content={content} />
                </div>
            </div>
        </motion.div>
    );
}
